export const GET_ROLES = 'GET_ROLES';
export const GET_ROLES_START = `${GET_ROLES}_START`;
export const GET_ROLES_SUCCESS = `${GET_ROLES}_SUCCESS`;
export const GET_ROLES_FAIL = `${GET_ROLES}_FAIL`;

export const GET_XMAPI_ROLES = 'GET_XMAPI_ROLES';
export const GET_XMAPI_ROLES_START = `${GET_XMAPI_ROLES}_START`;
export const GET_XMAPI_ROLES_SUCCESS = `${GET_XMAPI_ROLES}_SUCCESS`;
export const GET_XMAPI_ROLES_FAIL = `${GET_XMAPI_ROLES}_FAIL`;

// This is required by Invite Users in order to get roles filtered
// by role-on-role permissions, which is not currently supported by
// the xm-api roles endpoint
// https://xmatters.atlassian.net/browse/COR-23864
export const get = () => dispatch => {
  if (!window.XM_getRoles) {
    return;
  }

  dispatch({
    type: GET_ROLES_START,
  });

  window.XM_getRoles();
};

const uri = '/webapi/xm/1/roles';

export const getRoles = () => ({
  type: GET_XMAPI_ROLES,
  meta: {
    params: {
      embed: 'rolePermissions',
    },
    xmApi: true,
    method: 'getall',
    uri,
  },
});
